import { render } from "./infoPanel.vue?vue&type=template&id=64fa1c36&scoped=true&ts=true"
import script from "./infoPanel.vue?vue&type=script&lang=ts"
export * from "./infoPanel.vue?vue&type=script&lang=ts"

import "./infoPanel.vue?vue&type=style&index=0&id=64fa1c36&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fa1c36"]])

export default __exports__